export default "__VITE_ASSET__CW3aV0_X__"